<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <div style="width:100%">
        <v-toolbar flat>
            <v-select
                v-model="selectedListType"
                :items="listTypes"
                item-text="text"
                item-value="type"
                label="警報"
                hide-details />
        </v-toolbar>
        <Time v-if="selectedListType == 1" :sensors="sensors" :alarmsOnChart="alarmsOnChart" />
        <AlarmInfo v-if="selectedListType == 2" :sensors="sensors" :alarmsOnChart="alarmsOnChart" />
    </div>    
</template>

<script>
    import Time from '@/components/box/SensorAlarmHistoryTime';
    import AlarmInfo from '@/components/box/SensorAlarmHistoryAlarmInfo';
    export default {
        components: {
            Time,
            AlarmInfo
        },
        props: {
            sensors: null,
            alarmsOnChart: null
        },
        data: function () {
            return {
                listTypes: [
                    {type: 1, text: "時系列"},
                    {type: 2, text: "異常別発生回数"},
                ],
                selectedListType: 1
            }
        },
        methods: {
        }
    }
</script>
